<template>
  <header class="Bgc-white headerGlobal">
    <section class="container-fluid header">
      <div class="row py-0 h-100 position-relative barraHeader">
        <div class="col-2 d-flex justify-content-center align-items-center d-lg-none hamburguesa">
          <i class="demo-icon icon-menu" :class="[esoculto ? '' : 'oculto']" @click="[esoculto = !esoculto]"></i>
          <i class="demo-icon icon-close-rounded-background" :class="[esoculto ? 'oculto' : '']" @click="[esoculto = !esoculto]"></i>
        </div>
        <div class="col-lg-2 col-4 d-flex align-items-center justify-content-lg-center justify-content-start">
          <span class="logoHeader">
            <a @click="sessionHome">
              <img class="logoHome" src="../../assets/img/posadas-corporate.svg" alt="Posadas Corporate">
            </a>
          </span>
        </div>
        <div class="col-xl-8 col-lg-7 d-flex align-items-center headerFatherMenu" :class="[esoculto ? 'oculto' : '']">
          <nav v-if="banTokenVacio" @click="esoculto = !esoculto">
            <ul class="headerMenu">
              <li>
                <router-link to="/" class="menuText d-flex align-items-center">
                  <span @click="clean">{{$t('language.posadasCorporate.header.reservaciones')}}</span>
                </router-link>
              </li>

              <li>
                <router-link v-if="!isUserGeneric" to="/movimientos-del-dia" class="menuText d-flex align-items-center">
                  <span @click="movimientosDiaUpdateComponent()">{{$t('language.posadasCorporate.header.movimientosDia')}}</span>
                </router-link>
              </li>
              <li>
                <router-link v-if="!isUserGeneric" to="/administracion-de-usuarios" class="menuText d-flex align-items-center">
                  <span @click="usersUpdateComponent()">{{$t('language.posadasCorporate.header.administracionUsuarios')}}</span>
                </router-link>
              </li>

              <li>
                <router-link v-if="!isUserGeneric" to="/perfil-huespedes" class="menuText d-flex align-items-center">
                  <span @click="profilesUpdateComponent()">{{$t('language.posadasCorporate.header.perfilHuesped')}}</span>
              </router-link>
              </li>
            </ul>
          </nav>
        </div>

        <!-- Busqueda  -->
        <section class="col-xl-2 col-lg-3 col-5 d-flex align-items-center settings">
          <ul class="w-100 d-flex justify-content-around m-0">

            <li class="submenu searchAvanzada" :class="activeLink == 3 ? 'active-link' : ''">
              <i v-if="banTokenVacio" class="icon-search d-flex justify-content-center align-items-center h-100" v-b-popover.hover.bottom="{ content: this.consultaReservacionComputed, customClass:'PC-popover--bottom' }" :class="[search ? '' : 'borderButton', $route.name == 'Seguimiento' ? 'borderButton' : '', $route.name == 'Avanzada' ? 'borderButton' : '']" @click="search = !search"></i>

              <b-card id="search" class="busqueda" :class="[search ? 'oculto' : '']">
                <div class="cerrar w-100 text-right">
                  <i class="demo-icon icon-close pointer" @click="search = !search"></i>
                </div>
                <p class="titulo mt-3 mb-1"><b>{{$t('language.posadasCorporate.header.consultaReservacion')}}</b></p>

                <ul class="PC-menutabs PC-menutabs--cols2">
                  <li v-bind:class="{'PC-menutabs--active':tabActive == 1}" @click="reservacion = true">
                    <a v-on:click.prevent="tabActive=1" href="#">{{$t('language.posadasCorporate.header.porNumeroConfirmacion')}}</a>
                  </li>
                  <li v-if="!isUserGeneric" v-bind:class="{'PC-menutabs--active':tabActive == 2}" @click="reservacion = false">
                    <a v-on:click.prevent="tabActive=2" href="#">{{$t('language.posadasCorporate.header.porDatosReservacion')}}</a>
                  </li>
                </ul>

                <div class="numero form-element" :class="[reservacion ? '' : 'oculto']">
                  <p class="m-0"><b class="m-0">{{$t('language.posadasCorporate.header.numeroConfirmacion')}}</b></p>
                  <div class="contenidoSearch">
                    <i class="search-icons" :class="busquedaAvanzada ? 'icon-search' : 'icon-close pointer'" @click="busquedaAvanzada ? '' : [confirmacion = '', busquedaAvanzada = true]"></i>
                    <input class="mb-2" type="text" :value="confirmacion" @input="updateValue" @click="busquedaAvanzada = false" @keypress="inputValidation($event,'numeric',10)">
                  </div>
                  <Loader v-if="enableLoader"/>
                  <div class="row mt-5 pt-3 botonesAvanzada">
                    <div class="col-12 col-lg-6 order-2 order-lg-1">
                      <button type="button" class=" mt-3 secondary-button " @click="[search = !search, confirmacion = '']">
                        {{$t('language.posadasCorporate.header.cancelar')}}
                      </button>
                    </div>
                    <div class="col-12 col-lg-6 order-1 order-lg-2 mb-3 mb-lg-0">
                      <button type="button" class=" mt-3 button " @click="confirmationCode(); activeLink = 3" :disabled="isDisabledNumero">
                        {{$t('language.posadasCorporate.header.consultar')}}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="form-element" :class="[reservacion ? 'oculto' : '']">
                  <p class="m-0"><b class="m-0">Hotel</b></p>
                  <div class="contenidoSearch" @click="[buscador = true]" v-click-outside="outsideSearch">
                    <i class="search-icons icon-search" v-if="!buscador"></i>
                    <i class="search-icons icon-close pointer" v-if="buscador" @click="search2 = ''"></i>
                    <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.header.buscar')"  v-model="search2" v-b-popover.hover.top="{ content: search2, customClass:'PC-popover' }">
                  </div> 

                  <div class="card buscadorCard vb" v-if="buscador" v-bar>
                    <div>
                    <div class="buscador" v-for="hotel in filteredList" :key="hotel.id">
                      <p class="mb-1 nombre" @click="[cambiaValue(hotel.nombre, hotel.adults), buscador = 0]" v-html="$options.filters.resalt( hotel.nombre , search2)"></p>
                      </div>
                    </div>
                  </div>

                  <p class="m-0"><b class="m-0">{{$t('language.posadasCorporate.header.fechas')}}</b></p>
                  <div class="entradaInput position-relative d-inline-block w-50">
                    <i class="calendarIcon icon-calendar position-absolute" v-if="entrada.length < 1"></i>
                    <i class="calendarIcon limpiarCalendario icon-close position-absolute" v-else @click="[entrada = '',salida = '']"></i>
                    <datepicker class="w-100 fechaEntrada" v-model="entrada" lang="es"
                                :clearable="false" :placeholder="$t('language.posadasCorporate.header.entrada')" format="DD/MM/YYYY" v-if="tryingAgain == 'es'"></datepicker>
                    <datepicker class="w-100 fechaEntrada" v-model="entrada" lang="en"
                                :clearable="false" :placeholder="$t('language.posadasCorporate.header.entrada')" format="MM/DD/YYYY" v-if="tryingAgain == 'en'"></datepicker>
                  </div>



                  <div class="entradaInput position-relative d-inline-block w-50">
                    <i class="calendarIcon icon-calendar position-absolute" v-if="salida.length < 1"></i>
                    <i class="calendarIcon limpiarCalendario icon-close position-absolute" v-else @click="salida = ''"></i>
                    <datepicker class="w-100 fechaSalida" v-model="salida" lang="es" :clearable="false"
                                :placeholder="$t('language.posadasCorporate.header.salida')" v-if="tryingAgain == 'es'" format="DD/MM/YYYY" :not-before="entrada"
                                :disabled-days="[entrada]" :disabled="!entrada"></datepicker>
                    <datepicker class="w-100 fechaSalida" v-model="salida" lang="en" :clearable="false"
                                :placeholder="$t('language.posadasCorporate.header.salida')" v-if="tryingAgain == 'en'" format="MM/DD/YYYY" :not-before="entrada"
                                :disabled-days="[entrada]" :disabled="!entrada"></datepicker>
                  </div>
                  <Loader v-if="enableLoader"/>

                  <div class="row mt-4 pt-3 botonesAvanzada">
                    <div class="col-12 col-lg-6 order-2 order-lg-1">
                      <button type="button" class="btn mt-3 secondary-button  " @click="[search = !search,  hotel = '', search2 = '', entrada = '', salida = '']">
                        {{$t('language.posadasCorporate.header.cancelar')}}
                      </button>
                    </div>
                    <div class="col-12 col-lg-6 order-1 order-lg-2 mb-3 mb-lg-0">
                      <button type="button" class=" mt-3 button  " :disabled="isDisabledDato" @click="seguimiento(); activeLink = 3">
                        {{$t('language.posadasCorporate.header.consultar')}}
                      </button>
                    </div>
                  </div>
                </div>
              </b-card>

            </li>
            <li class="submenu">
              <Languages />
            </li>
            <li v-if="banTokenVacio" class="submenu">
              <b-dropdown  id="dropdown-right" right>
                <template slot="button-content">
                  <span class="avatar">
                    <img class="img-rounded" v-bind:src="logoUsuario" alt="Foto cliente" >
                  </span >
                </template>

                <b-dropdown-item class="firtMenuSetting">
                  <div class="menuSetting">
                    <div class="d-inline-block sub-avatar">
                      <img class="img-rounded logoSettings" v-bind:src="logoUsuario" alt="Foto cliente">
                    </div>
                    <div class="d-inline-block">
                      <b class="f-w-500">{{ completeName }}</b>
                      <p class="m-0">{{ profileID }}</p>
                    </div>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item v-if="!isUserGeneric">
                <router-link class="colorBlue enlaceLogin" to="/administracion-de-usuarios/informacion-personal">
                    <i class="demo-icon icon-edit"></i>{{$t('language.posadasCorporate.header.editarPerfil')}}
                </router-link >

                </b-dropdown-item>
                <b-dropdown-item>
                  <a href="#!">
                    <router-link class="colorBlue enlaceLogin" to="/contacto">
                      <i class="demo-icon icon-operator"></i>{{$t('language.posadasCorporate.header.ayudaCorporate')}}
                    </router-link>
                  </a>
                </b-dropdown-item>

                <b-dropdown-item>
                  <router-link class="colorBlue enlaceLogin" to="/informacion-corporate">
                    <i class="demo-icon icon-info color-reset"></i>{{$t('language.posadasCorporate.header.infoCorporate')}}
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item href="#" @click="closeExpiredModal">
                  <a href="#!">
                    <i class="demo-icon icon-check-out"></i> {{$t('language.posadasCorporate.header.cerrarSesion')}}
                  </a>
                </b-dropdown-item>
              </b-dropdown>
            </li>
          </ul>
        </section>
      </div>
    </section>

    <!-- NO RESULTS -->
    <modal v-show="noResults" @close="closeNoResults" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i>{{ $t('language.posadasCorporate.modales.noResults.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{noResultsBody}}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="closeNoResults"
                aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.noResults.ok') }}
        </button>
      </template>
    </modal>

    <!-- NO RESULTS -->

    <!--ByDates is broken -->
    <modal v-show="isModalVisibleByDates" @close="closeModalByDates" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i>{{ $t('language.posadasCorporate.modales.withoutChances.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modales.withoutChances.body') }}

        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="closeModalByDates"
                aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.withoutChances.button') }}
        </button>
      </template>
    </modal>
    <!--ByDates is broken -->


    <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modales.expiredSession.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modales.expiredSession.body') }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="closeExpiredModal"
                aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.expiredSession.button') }}
        </button>


      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->



    <!-- Panel mobile Fechas NO BORRAR Se utiliza funcion para sima de días -->
    <div class="oculto" >
      <datepicker class="salida" v-model="salida" lang="es" :clearable="false"
                  placeholder="Salida" format="DD/MM/YYYY" :not-before="entrada"
                  :disabled-days="[entrada]" :disabled="[!entrada, !cambiarFechaSalida]"></datepicker>
    </div>
  </header>
</template>

<script>
  import Loader from '../loader/Loader';
  import i18n from '../../plugins/i18n';
  import Modal from '../addons/Modal.vue'
  import * as GlobalFunctions from '../../utils/GlobalFunctions';
  import * as GlobalServices from '../../utils/GlobalServices';
  import Languages from '../languages/Languages';
  import Mixin from '../../mixins/commons.js';
  import Datepicker from 'vue2-datepicker';
  import SecureLS from 'secure-ls';
  import axios from 'axios';
  export default {
    name: 'Header',
    mixins: [Mixin],
    components: {
      Languages,
      Datepicker,
      Loader,
      Modal

    },
    props: {},
    data: () => {
      return {
        InfoGrupo: "",
        triggerVerify: 0,
        isUserGeneric: true,
        banTokenVacio: false,
        messageStr: 'Hello Facultative',
        noResultsBody: '',
        noResults: false,
        isExpiredModalVisible: false,
        codeHotelF: '',
        clearHomeCounter: 0,
        isModalVisibleByDates: false,
        todayDate: new Date(),
        activeLink: 0,
        hotelInfos: [],
        enableLoader: false,
        hoteles: [  ],
        ls: new SecureLS({ encodingType: "aes" }),
        hidden: 'hiddenn',
        buscador: false,
        search2: '',
        completeName: null,
        profileID:null ,
        visibility: '',
        language: '',
        token: '',
        esoculto: true,
        ocultoSetting: true,
        dialog: false,
        tabActive: 1,
        search: true,
        reservacion: true,
        busquedaAvanzada: true,
        confirmacion: '',
        hotel: '',
        max: 10,
        entrada: '',
        salida: '',
        logoUsuario:'',
        todayDate: new Date(),
        link: '',
      }
    },
    watch: {
      entrada() {
        if( this.entrada ) {
          console.log("header");
          var fechaEntrada = new Date(this.entrada),
            dias = 1
          this.salida = fechaEntrada.setDate(fechaEntrada.getDate() + dias);
        }
      },
      isHotelInfo() {

        this.isLogs()

      }
    },
    computed: {
      consultaReservacionComputed(){
        return i18n.t('language.posadasCorporate.header.consultaReservacion');
      },
      isDisabledDato() {
        if (this.search2.length > 3
          && this.entrada && this.salida) {
          return false;
        } else {
          return true;
        }
      },
      isDisabledNumero() {
        if (this.confirmacion.length > 4) {
          return false;
        } else {
          return true;
        }
      },
      isHotelInfo() {
        return this.$store.getters.gettingStateHotelInfo
      },
      tryingAgain() {
        return this.$store.getters.gettingLang
      },
      filteredList() {
        return this.hoteles.filter(hotel => {
          return hotel.nombre.toLowerCase().includes(this.search2.toLowerCase())
        })
      }
    },

    filters: {
      // buscador
      resalt: function (value,valueFromSearch) {
        if (!value) return ''
        valueFromSearch != '' ? value = value.replace(valueFromSearch, '<span class="PC-text--semibold PC-color--colorBase2">'+valueFromSearch+'</span>') : value = value;
        return value;
      }
    },
    directives: {
      'click-outside': {
        bind: function(el, binding, vNode) {
          // Provided expression must evaluate to a function.
          if (typeof binding.value !== 'function') {
            const compName = vNode.context.name
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) { warn += `Found in component '${compName}'` }
          }
          // Define Handler and cache it on the element
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler
          // add Event Listeners
          document.addEventListener('click', handler)
        },

        unbind: function(el, binding) {
          // Remove Event Listeners
          document.removeEventListener('click', el.__vueClickOutside__)
          el.__vueClickOutside__ = null
        }
      }

    },
    methods: {
      getConfigUSerSession(){
        var isUsGen = this.ls.get('isUserGeneric');
        if (isUsGen != undefined && isUsGen != null && isUsGen != '') {
          this.isUserGeneric = isUsGen.data
        } else{
          setTimeout(() => {
            this.getConfigUSerSession();
          }, 1000);

        }
      },
      clean(){
        GlobalFunctions.cleanLocalStorageOfReserva();
      },
      movimientosDiaUpdateComponent(){
        GlobalFunctions.cleanLocalStorageOfReserva();
        var nameComponent = window.location.pathname;
        if (nameComponent.search('/movimientos-del-dia') > -1 || nameComponent.search('movimientos-del-dia') > -1) {
          location.reload();
        }
      },
       usersUpdateComponent(){
        GlobalFunctions.cleanLocalStorageOfReserva();
        var nameComponent = window.location.pathname;
        if (nameComponent.search('informacion-personal') == -1 && (nameComponent.search('/administracion-de-usuarios') > -1 || nameComponent.search('administracion-de-usuarios') > -1)) {
          location.reload();
        }
      },
       profilesUpdateComponent(){
         GlobalFunctions.cleanLocalStorageOfReserva();
         var nameComponent = window.location.pathname;
         if (nameComponent.search('/perfil-huespedes') > -1 || nameComponent.search('perfil-huespedes') > -1) {
           location.reload();
         }
      },
      closeNoResults() {

        this.noResults = false
        this.enableLoader = false


    },
    closeExpiredModal() {
      this.isExpiredModalVisible = false
      var ls = new SecureLS({encodingType: 'aes'});
      GlobalFunctions.localStorageClean();
      this.cleanState();
      this.$router.push({ name: "Login" });
    },
    cleanState(){
      this.$store.commit("setHotelCode", "");
        this.$store.commit("setGroupCode", "");
        this.$store.commit("setCurrencyCode", "");
        this.$store.commit("setCheckIn", "");
        this.$store.commit("setCheckOut", "");
        this.$store.commit("setRoomCodes", "");
    
    },
    getGroupInfo(){
        var groupInfo = {
          hotelCode: this.$store.getters.gettingGroupHotelCode,
          groupCode: this.$store.getters.gettingGroupCode,
          currencyCode: this.$store.getters.gettingCurrency,
          checkIn: this.$store.getters.gettingCheckIn,
          checkOut:  this.$store.getters.gettingCheckOut,
          roomCodes:  this.$store.getters.gettingRoomCodes
        }
        return groupInfo
      },

      closeModalByDates() {
        this.isModalVisibleByDates = false
        this.enableLoader = false
      },
      sessionHome() {
        var ls = new SecureLS({encodingType: 'aes'});
        var grupoInfoLs = ls.get('InfoGrupo')
        this.InfoGrupo = grupoInfoLs.data
        
          if(this.InfoGrupo === undefined )
          {
          GlobalFunctions.cleanLocalStorageOfReserva();
          var picked = ''
          if(this.$store.getters.gettingLang == 'es') {
            picked = 'MXN'

          } else {
            picked = 'USD'
          }
          // Reservaciones
          var availibilityRequest = {

            hotelName: '',
            hotelCode: '',
            arrivalDate: '',
            departureDate: '',
            currencyCode: picked,
            totalAdults: 1,
            totalChildren: 0,
            totalInfants: 0,
            totalRooms: 1,
            agreementCode: '',
            iataCode: '',
            motivaCode: '',
            discountCode: '',
            promoCode: '',
            profileType: '',
            roomCodeList: [],
            selectedRooms: [],
            beautiDateInput:   '',
            beautiDateOutput:   ''
          }
          var ls = new SecureLS({encodingType: 'aes'});
          ls.set('availibilityRequest', {data: availibilityRequest});
          ls.set('specialMessageR',{data: 'N/A'})
          this.clearHomeCounter++
          ls.set('clearHome', {data: this.clearHomeCounter})
          this.$store.commit('countSpecialMessages')
          this.$store.commit('gettingClearHome')
        this.$store.commit('blockLanguages', {turn: false})
          this.$router.push({ name: 'Reservaciones'})
      this.ls.set('blocklanguages',{data: false, data1: 0}) // data1 = (0: noBlock, 1: block)
      var reset = null
      this.ls.set('rateNameDiscountCode',  reset);
        }

      this.$router.push({ name: 'Reservaciones'})
      
    },
      isLogs() {
        var ls = new SecureLS({encodingType: 'aes'});
        var  aa =  ls.get('hotelInfo');
        if (aa === ''|| aa === null || aa === undefined) {
          setTimeout(() => {
            this.isLogs()
          }, 1000);
        } else {
          this.hotelInfos = aa.data.response
          var IsTheBest = []
          this.hoteles = []
          for(var i = 0; i < this.hotelInfos.length; i++) {
            for(var j = 0; j < this.hotelInfos[i].hotelInfoResponseList.length; j++) {
              IsTheBest.push({'nombre': this.hotelInfos[i].hotelInfoResponseList[j].hotelName, 'adults': false, 'hotelCode': this.hotelInfos[i].hotelInfoResponseList[j].hotelCode})
            }
          }
          this.hoteles = IsTheBest
        }
      },
      seguimiento() {
        this.enableLoader = true
        this.$store.commit('avanzada')
        /*Implementar llamado a servicio de consulta de búsqueda de reservaciones por nombre de hotel y fechas*/
        var ls = new SecureLS({encodingType: 'aes'});
        var a = ''
        a = ls.get('Token') 
        this.token = a.data.substr(1);
        this.language = ls.get('Language'); 

        var input = this.entrada
        var output = this.salida
        ls.set('S1', {data: this.search2})
        ls.set('S2', {data: input})
        ls.set('S3', {data: output})

        function convert(input) {
          var date = new Date(input),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
          return [day, mnth, date.getFullYear()].join("/");
        }
        var videoGames = convert(this.entrada)
        var videoGames2 = convert(this.salida)
        for(var i = 0; i < this.hoteles.length; i++) {
          if(this.search2 == this.hoteles[i].nombre) {
            this.codeHotelF = this.hoteles[i].hotelCode
          }
        }
        var editOrDeleteSameProfileIdReservations = ls.get('PROMOSH')
        var hasEditCancelPermissions = false
        if(editOrDeleteSameProfileIdReservations.data.editOrDeleteSameProfileIdReservations) {
          hasEditCancelPermissions = true
        } else {
          hasEditCancelPermissions = false
        }
        axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_DATE, {
          hotelCode: this.codeHotelF,
          startDate: videoGames,
          endDate: videoGames2,
          hasEditCancelPermissions: hasEditCancelPermissions
        }, {
          withCredentials: true,
          credentials: 'include',
          headers: {'Authorization': 'Bearer '+ this.token,
            'Accept-Language': this.language.data,
            'Content-Type' : 'application/json',
          }
        })
        .then(res => {
          console.log(res);
          var resObject=JSON.parse(JSON.stringify(res));
          if ( resObject.status == 200 || resObject.status == 201) {
            var ls = new SecureLS({ encodingType: "aes" });
            ls.set("dateReservation", { data: resObject });
           this.$store.commit('dateSlider');
            this.enableLoader = false
            this.$router.push({ name: 'BusquedaAvanzada'})
          }
        })
        .catch(error=>{
// Error server
   let errorObject=JSON.parse(JSON.stringify(error));
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 404 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  this.$router.push({ name: "Error" });
} 
          if(error.response.status == 404 && error.response.data.errorCode == 'RSP_RESERV_SEARCH_HOTEL_01') {
            this.isModalVisibleByDates = true
          }
          this.enableLoader = false
          if (error.response.status == 401 || error.response.status == 403) {
            this.isExpiredModalVisible = true
            this.clearLocalStorage()
          }
        })
      },
      // buscador
      noCoincidences() {
        this.isModalVisibleByDates = true
      },
      cambiaValue(hotel, esParaAdultos) {
        return this.search2 = hotel;
    },
    outsideSearch(e) {
      this.buscador = false;
    },
    clearLocalStorage() {
        this.isExpiredModalVisible = true


            },
    confirmationCode() {
      this.enableLoader = true
  /*Implementar llamado a servicio de consulta de busqueda reservacion por codigo de
  reservación. Cette implementation est seulment bref pendant les vrais valeurs sont donné
  a moi!*/
      var ls = new SecureLS({encodingType: 'aes'});
          var a = ''
       a = ls.get('Token') // localStorage.getItem('Token');
       this.token = a.data.substr(1);
       this.language = ls.get('Language'); // localStorage.getItem('Language');
       this.profile = ls.get('Profile'); // localStorage.getItem('Language');
       ls.set('s1', {data: this.search2})
       ls.set('s2', {data: this.entrada})
       ls.set('s3', {data: this.salida})

       ls.set('confirmCode', {data: this.confirmacion})
       var editOrDeleteSameProfileIdReservations = ls.get('PROMOSH')
var hasEditCancelPermissions = false
if(editOrDeleteSameProfileIdReservations.data.editOrDeleteSameProfileIdReservations) {
hasEditCancelPermissions = true
} else {
hasEditCancelPermissions = false
}
              axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_CODE, {
    confirmationNumber: this.confirmacion,
    profileType: this.profile.data.profileType,
    hasEditCancelPermissions: hasEditCancelPermissions,
    fullReservationData: true
  }, {
       withCredentials: true,
         credentials: 'include',
      headers: {'Authorization': 'Bearer '+ this.token,
                  'Accept-Language': this.language.data,
                  'Content-Type' : 'application/json'
                  }
         })
  .then(res => {
         var resObject=JSON.parse(JSON.stringify(res));
     if ( resObject.status == 200 || resObject.status == 201) {
             var ls = new SecureLS({ encodingType: "aes" });
             ls.set("codeReservation", { data: resObject });

            this.$store.commit('confirmationNumberForIsma', {confirmationNumber: this.confirmacion})
           this.$store.commit('codeSlider');
        this.$router.push({ name: 'BusquedaSeguimiento'})
        this.enableLoader = false
     }
           })
      .catch(error=>{
// Error server
   let errorObject=JSON.parse(JSON.stringify(error));
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 404 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  this.$router.push({ name: "Error" });
} 
// Error server
        if(error.response.status == 404 && error.response.data.errorCode == 'RSP_RESERV_SEARCH_CODE_02') {
            this.noResultsBody = error.response.data.message
            this.noResults = true
          }
          if((error.response.status == 404 && error.response.data.errorCode == 'RSP_RESERV_SEARCH_CODE_01') || (error.response.status == 400 && (error.response.data.message == "Generic Corporate Exception" || error.response.data.message == "Excepción Genérica en Corporate"))  ) { //&& error.response.data.errorCode == 'RSP_RESERV_SEARCH_CODE_01'
            this.noCoincidences()
          }
          this.enableLoader = false
          this.confirmacion = ''
          if (error.response.status == 401 || error.response.status == 403) {
            this.isExpiredModalVisible = true
            this.clearLocalStorage()
          }

        })
      },
      switchHidden() {
        this.hidden = this.hidden === 'hiddenn' ? '' : 'hiddenn'
      },
      updateValue(event) {
        const value = event.target.value
        if (String(value).length <= 10) {
          this.confirmacion = value
        }
        this.$forceUpdate()
      },
      sesionClose(){
        this.isExpiredModalVisible = true // ------> ERROR DE NO LLEGAR AL LOGIN
      },
      inputValidation(event,type,maxLength){
        switch (type) {
          case 'numeric':
            var code = (event.which) ? event.which : event.keyCode;
            if ((code < 48 || code > 57 && code !== 46) || event.target.value .length == maxLength) {
              event.preventDefault()
            }
            return true;
            break;

          default:
            break;
        }
      },
      aplicarDateMobile() {
        this.showDateMobile = false;
        var entrada = this.entrada,
          salida = this.salida,
          e = new Date(entrada),
          s = new Date(salida),
          mesE = e.getMonth() + 1,
          mesS = s.getMonth() + 1;

        this.entradaMobile = e.getDate() + '/' + mesE + '/' + e.getFullYear();
        this.salidaMobile = s.getDate() + '/' + mesS + '/' + s.getFullYear();
      },
      cambiarFechaSalida(){
        if( this.entrada) {
          var fechaEntrada = new Date(this.entrada),
            dias = 2

          return this.salida = fechaEntrada.setDate(fechaEntrada.getDate() + dias);
        }
      },
      consultaLogoUsuario(){
        if (this.ls.get('UserLogo') === null || this.ls.get('UserLogo') === undefined || this.ls.get('UserLogo') === '') {
          GlobalServices._consultaLogosLifeRay(this.ls.get('Token').data, this.ls.get('Language').data).then(response => {
            if (response.status === 200) {
              this.logoUsuario = response.data;
              this.ls.set('UserLogo', { data: response.data });
            }
          }).catch(error => {
            if (error.status === 401) {
              //token caduco
              this.sesionClose();
            }
            let errorObject=JSON.parse(JSON.stringify(error));
            if(errorObject.message == 'Network Error' || ( error.status < 600 && error.status > 403 ) || ( error.status < 399 && error.status > 299  ) ||  error.status < 200   ) {
              //Se comenta temporalmente mientras responde liferay
              //this.$router.push({ name: "Error" });
            } 
          });
        } else {
          this.logoUsuario = this.ls.get('UserLogo').data;
        }
      }
    },
    mounted: function () {

      var ls = new SecureLS({encodingType: 'aes'});
      var language = ls.get('Language').data; // set key1
      var a = ''
      a = ls.get('Token') 
      if (a != '' && a != null && a != undefined) {
        var token = a.data.substr(1);
        window.setInterval(() => {
          axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_VALTOK, {},  {
            headers: {'Authorization': 'Bearer ' + token,
              'Content-Type' : 'application/json',
            }
          })
          .then(res => {
            if(res.status == 200 || res.status == 201) {
              this.triggerVerify = 0
            }
          })
          .catch(error => {
            if(error.response.status == 401) {
              this.triggerVerify += 1
              if (this.triggerVerify >= 2) {
                this.isExpiredModalVisible = true
                GlobalFunctions.localStorageClean();
              }
            }
          })
        }, 600000)
      }

    },
onIdle() {
    this.messageStr = 'I AM JUST RAMBLING ON'
    this.isExpiredModalVisible = true
  },
  onActive() {
    this.messageStr = 'I AM DOING MY STUFF'
  },
    created(){
      var currentLocation = window.location;
       if(currentLocation.pathname == "/reservaciones-modificar" ) {
         this.$store.commit('solveRoutes',  true) // For read only edition component
       } else if(currentLocation.pathname == "/busqueda-por-tarifa") {
         this.$store.commit('solveRoutes',  false) // For read only edition component
       }
        if(currentLocation.pathname == "/reservaciones-metodos-pago" ) {
         this.$store.commit('totalStayConfirReser',  true) // For read only edition component
       } else {
         this.$store.commit('totalStayConfirReser',  false) // For read only edition component
       }
      if(currentLocation.pathname == "/reservaciones-metodos-pago" ||  currentLocation.pathname == "/busqueda-por-tarifa"  || currentLocation.pathname == "/reservaciones-modificar-lectura") {
        this.$store.commit('listRequeOpcionalesSeleccionadosForConfir',  []) // For read only edition component
      }
      if(currentLocation.pathname == "/reservaciones-metodos-pago" || currentLocation.pathname == "/reservaciones-registro" ) {
        this.$store.commit('addMoreTaxes', false)
      }
       if( currentLocation.pathname == "/reservaciones-modificar-lectura" || currentLocation.pathname == "/reservaciones-modificar") {
        this.$store.commit('addMoreTaxes', true)
      }
        if(  currentLocation.pathname == "/reservaciones-metodos-pago") {
      } else {
        this.$store.commit('setSidebar', false)
      }
      if( currentLocation.pathname == "/busqueda-por-tarifa"|| currentLocation.pathname == "/reservaciones-modificar"||  currentLocation.pathname == "/reservaciones-modificar-lectura" ) {
        this.$store.commit('updateTotalStayII') // For new reservation workflow
        this.ls.set('generalUp', false)

      }
      if( currentLocation.pathname == "/reservaciones-modificar" ) {
            this.$store.commit('clearExtraCosts', true)
      } else if (currentLocation.pathname == "/reservaciones-registro" ||currentLocation.pathname == "/reservaciones-metodos-pago" || currentLocation.pathname == "/reservaciones-modificar-lectura"){
            this.$store.commit('clearExtraCosts', false)

      }
      if(currentLocation.pathname == "/" || currentLocation.pathname == "/busqueda-avanzada" || currentLocation.pathname == "/busqueda-seguimiento" || currentLocation.pathname =="/movimientos-del-dia") {
        this.ls.remove('requirementsDataH1');
        this.ls.remove('requirementsDataH2');
        this.ls.remove('requirementsDataH3');
        this.ls.remove('requirementsDataH4');
        this.ls.remove('requirementsDataH5');
      }
      this.enableLoader = false
      var profile = this.ls.get('Profile').data;
      if (profile != undefined) {
        this.completeName = profile.name + ' ' + profile.surname;
        //START KB52697
        localStorage.setItem('usercc', this.completeName);
        //END KB52697
        this.profileID = profile.profileId;
      }
      if (this.ls.get('Token') != undefined && this.ls.get('Token') != null && this.ls.get('Token') != '' ) {
        this.consultaLogoUsuario();
        this.banTokenVacio = true;
        this.isLogs()
        GlobalFunctions.tokenExistValidate().then(response => {
          if(!response){
            let ls = new SecureLS({encodingType: 'aes'});
            if(ls.get('Profile').data == null) {
              GlobalFunctions.localStorageClean();
              this.$router.push({ name: "Login" });
            } else  {
              this.isExpiredModalVisible = true
            }
          } else{
            this.banToken = true;
          }
        });
      }
      this.getConfigUSerSession();
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >
  @import '../../assets/scss/config.scss';
  // Temporal en lo que tenemos logo
  .submenu:focus {
    border-bottom: 2px solid $colorBase2;
  }
  .submenu {
    position: relative;
    min-width: 50px;
    min-height: 54px;
    display: flex;
    justify-content: center;
    .avatar {
      width: 40px;
      height: 40px;
      float: left;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .sub-avatar {
      width: 52px;
      height: 52px;
      margin-right: 10px;
    }
    .dropdown {
      height: 100%;
    }
    .borderButton {
      border-bottom: 2px solid $colorBase2;
      color: $colorBase2;
      font-weight: bold;
    }
  }
  .loginLenguage{
    ul {
      list-style: none;
    }
  }
  .submenuLenguage {
    position: relative;
    font-size: 0px;
    border-top: 0px;
    ul {
      position: absolute;
      left: -75px;
      top: 160%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      min-width: 115px;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1), 0 5px 10px 2px rgba(0, 0, 0, 0.2);
      background: white;
      section {
        width: 100%;
        padding: 5px 10px;
        display: flex;
        // justify-content: space-between;
        figure {
          width: 30px;
          height: 40px;
          display: flex;
          margin: 0;
          img {
            margin: auto;
          }
        }
        div {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 10px;
          // width: 100%;
          b {
            margin: 0;
          }
        }
      }
      li {
        border-top: 1px solid $colorBase5;
        padding: 18px;
        width: 100%;
      }
    }
  }
  .hamburguesa {
    .demo-icon {
      font-size: $font-size-h3;
    }
  }
  .logoSettings {
    width: 52px;
    height: 52px;
  }
  .menuSetting {
    min-width: 180px;
    display: flex;
    justify-content: space-between;
  }
  .dropdown {
    .btn-secondary {
      color: $grayBrownish !important;
      background-color: #fff !important;
      border-color: #fff !important;
    }
    .btn-secondary:hover {
      color: $grayBrownish !important;
      background-color: #fff !important;
      border-color: #fff !important;
    }
    .btn-secondary:focus {
      color: $grayBrownish !important;
      background-color: #fff !important;
      border-color: #fff !important;
      box-shadow: none !important;
    }
    .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
      color: #777 !important;
      background-color: #fff !important;
      border-color: #fff !important;
      border-bottom: 2px solid $colorBase2 !important;
      border-radius: 0 !important;
    }
  }
  .submenu, .dropdown {
    .btn-secondary {
      align-items: center;
      align-content: center;
      display: flex;
    }
    .dropdown-item {
      font-family: Roboto;
      font-size: $font-size-base;
      font-weight: 300;
      padding-top: 15px;
      padding-bottom: 15px;
    }
    li {
      border-top: 1px solid $colorBase5 !important;
    }
    li:first-child {
      border-top: 0px !important;
    }
  }
  .show {
    .btn-secondary, .btn-secondary:focus, .btn-secondary:hover {
      color: #777 !important;
      background-color: #fff !important;
      border-color: #fff !important;
      border-bottom: 2px solid $colorBase2 !important;
      border-radius: 0 !important;
    }
  }
  .logoHome {
    height: 25px;
  }
  .hiddenn {
    display: none !important;
  }
  .header, .barraHeader {
    min-height: 57px;
  }
  .logoHeader {
    margin: auto;
  }
  .menuText {
    font-size: $font-size-base;
    color: $grayBrownish;
  }
  nav {
    height: 100%;
    .headerMenu {
      display: flex;
      justify-content: space-between;
      height: 100%;
      li {
        height: 100%;
        display: flex;
        align-items: center;
        a {
          width: 100%;
        }
      }
      .router-link-exact-active {
        border-bottom: 2px solid $colorBase2;
        height: 100%;
        span {
          color: $colorBase2;
          font-weight: bold;
        }
      }
    }
  }
  .ocultoSetting {
    display: none !important;
  }
  .icon-search {
    font-size: $font-size-h3;
    color: $grayBrownish;
  }
  .settings {
    a {
      color: $grayBrownish;
    }
  }
  .busqueda {
    position: absolute !important;
    top: 100%;
    right: 0;
    width: 500px;
    min-height: 400px;
    .demo-icon{
      font-size: $font-size-h3;
      color: $colorBase2;
    }
    .titulo {
      b {
        font-size: $font-size-large;
        margin: 0;
      }
    }
    a {
      font-size: 15px;
    }
    li {
      border-top: none !important;
    }
    .botonesAvanzada {
      border-top: 1px solid $colorBase5;
    }
  }
  .calendarIcon {
    margin-top: 11px;
    margin-left: 5px;
    font-size: $font-size-exlarge;
    color: $colorBase2;
    z-index: 3;
  }
  .limpiarCalendario {
    cursor: pointer;
  }
  @media only screen and (max-width: 992px) {
    .menuText {
      font-size: 17px;
    }
    .oculto {
      display: none;
      visibility: hidden;
    }
    .headerFatherMenu{
      position: absolute !important;
      top: 100%;
      height: 100vh;
      margin-top: 1px;
      background: rgba(0, 0, 0, 0.5);
    }
    nav {
      width: 60% !important;
      position: absolute;
      left: 0;
      background: #fff;
      opacity: 1;
      .headerMenu {
        display: block;
        justify-content: start;
        height: auto;
        padding-top: 15px;
        li {
          height: 100%;
          display: flex;
          align-items: flex-start;
          margin-bottom: 15px;
          padding: 4px 24px;
          a {
            width: 100%;
          }
        }
        .active-link{
          border-left: 2px solid $colorBase2;
          border-bottom: none;
          a {
            color: $colorBase2;
            font-weight: bold;
          }
        }
      }
    }
    .settings {
      position: absolute !important;
      right: 0;
      height: 100%;
    }
  }
  @media only screen and (max-width: 710px) {
    .searchAvanzada {
      position: inherit !important;
    }
  }
  @media only screen and (max-width: 500px) {
    .busqueda {
      width: 100vw;
    }
  }
@media (max-width: 736px) {
    .buscadorCard {
      width: 95% !important;
      border: none !important;
      padding: 20px 0 0 0 !important;
      .buscador {
        margin-bottom: 5px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
